import {
    DELETE_PUBLIC_LIABILITY_SUCCESS,
    DELETE_PUBLIC_LIABILITY_FAILURE,
  } from "../constants/MyM";
  import { deleteApi } from "../../utils/apiCall";
  
  const deletePublicLiabilitySuccess = (data) => {
    return {
      type: DELETE_PUBLIC_LIABILITY_SUCCESS,
      payload: data,
    };
  };
  
  const deletePublicLiabilityFailure = (data) => {
    return {
      type: DELETE_PUBLIC_LIABILITY_FAILURE,
      payload: data,
    };
  };
  
  export const deletePublicLiability = (id) => {
    return async (dispatch, getState) => {
      const { error, result } = await deleteApi(`/public_liability_certificate/${id}`);
      if (!error) {
        return dispatch(deletePublicLiabilitySuccess(result));
      }
      return dispatch(deletePublicLiabilityFailure(result));
    };
  };
  